import InitialInfo from "./content/initial-info.jsx";
import FactAddress from "./content/fact-address.jsx";
import OtherBo from "./content/other-bo.jsx";
import DispatchClosure from "./content/dispatch-closure.jsx";
import Displacements from "./content/displacements.jsx";
import Supports from "./content/supports.jsx";
import Attendance from "./content/attendance.jsx";
import Cameras from "./content/cameras.jsx";
import MainDispatch from "./content/main-dispatch.jsx";
import Attachments from "./content/attachments.jsx";
import Garrison from "./content/garrison.jsx";

const hasItems = (items) => Array.isArray(items) && items.length > 0;

export default function ReportContent({ data, printOptions, boName }) {
    const dispatch = data?.dispatch ?? {};

    const sections = {
        factAddress: dispatch?.supportforgarrisonispatch_id == null,
        otherOccurrenceNumber: dispatch?.otheroccurrencenumber,
        dispatchStatus: dispatch?.dispatch_status,
        displacements: hasItems(dispatch?.displacements),
        cameras: hasItems(dispatch?.cameras),
        attendance: dispatch?.attendance,
        supports: hasItems(dispatch?.supports),
        mainDispatch: dispatch?.mainDispatch,
        attachment: hasItems(dispatch?.attachment),
    }

    return (
        <div className="space-y-4">
            <InitialInfo title="DADOS INICIAIS" data={data} boName={boName} printOptions={printOptions}/>

            <Garrison title="GUARNIÇÃO" data={data}/>

            {sections.factAddress && (
                <FactAddress title="ENDEREÇO DO FATO" data={data}/>
            )}

            {sections.otherOccurrenceNumber && (
                <OtherBo title="BO de terceiros" data={data}/>
            )}

            {!sections.dispatchStatus && (
                <DispatchClosure title="ENCERRAMENTO" data={data}/>
            )}

            {sections.displacements && (
                <Displacements title="DESLOCAMENTOS" data={data}/>
            )}

            {sections.cameras && (
                <Cameras title="RESERVA DE IMAGEM" data={data}/>
            )}

            {sections.attendance && (
                <Attendance title="ATENDIMENTO" data={data}/>
            )}

            {sections.supports && (
                <Supports title="APOIOS" data={data}/>
            )}

            {sections.mainDispatch && (
                <MainDispatch title="DESPACHO PRINCIPAL" data={data}/>
            )}

            {sections.attachment && (
                <Attachments title="ANEXOS" data={data} printOptions={printOptions}/>
            )}
        </div>
    )
}